import moment from 'moment'

// WHY: react-day-picker/moment(addon) の MomentLocaleUtils は addon 内蔵の moment で
// moment.localeData('ja') を呼ぶ。Vite の依存最適化で moment / moment/locale/ja / addon が
// 別インスタンスに分裂し、アプリ側 `import 'moment/locale/ja'` が addon の moment に届かないため
// ja が en にフォールバックしてカレンダーの曜日が英語表記（Su/Mo…）になる。
// bundler のインスタンス共有に依存せず確実に日本語化するため、曜日・月名は固定配列で持ち、
// 数値フォーマット（ロケール非依存）だけ moment を使う自己完結の localeUtils を提供する。
// react-day-picker v7 の LocaleUtils インターフェースに準拠。

const WEEKDAYS_SHORT = ['日', '月', '火', '水', '木', '金', '土']
const WEEKDAYS_LONG = ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日']
const MONTHS = [
  '1月',
  '2月',
  '3月',
  '4月',
  '5月',
  '6月',
  '7月',
  '8月',
  '9月',
  '10月',
  '11月',
  '12月',
]

type DateFormat = string | string[]

export const jaLocaleUtils = {
  formatDay: (day: Date) =>
    `${moment(day).format('YYYY年M月D日')}(${WEEKDAYS_SHORT[day.getDay()]})`,
  formatMonthTitle: (date: Date) => moment(date).format('YYYY年M月'),
  formatWeekdayShort: (weekday: number) => WEEKDAYS_SHORT[weekday],
  formatWeekdayLong: (weekday: number) => WEEKDAYS_LONG[weekday],
  getFirstDayOfWeek: () => 0,
  getMonths: () =>
    MONTHS as unknown as [
      string,
      string,
      string,
      string,
      string,
      string,
      string,
      string,
      string,
      string,
      string,
      string,
    ],
  formatDate: (date: Date, format: DateFormat = 'YYYY/MM/DD') =>
    moment(date).format(Array.isArray(format) ? format[0] : format),
  parseDate: (str: string, format: DateFormat = 'YYYY/MM/DD'): Date => {
    const m = moment(str, Array.isArray(format) ? format[0] : format, true)
    // NOTE: react-day-picker の型は parseDate(): Date だが、実行時は無効日付で undefined を許容する
    return m.isValid() ? m.toDate() : (undefined as unknown as Date)
  },
}
